exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".group-a9348863 label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.buttons-ce78e537{display:flex;flex-flow:column nowrap}.buttons-ce78e537>:first-child{margin-bottom:15px}\n", ""]);

// Exports
exports.locals = {
	"group": "group-a9348863",
	"buttons": "buttons-ce78e537"
};